<div class="web">
  <div class="carruselContainer">
    <div class="carruselCenter">
      <div class="container-fluid p-0" style="width:100%;">
        <mdb-carousel [animation]="'fade'" style="padding: 0;margin: 0;">
          <mdb-carousel-item>
            <a class="w-100">
              <!--div class="divTexto"-->
              <div class="carrusel-position-text">
                <p class="tituloBanner">
                  
                </p>
                <!--p class="descripBanner">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti fugit ea eaque libero aut autem sed quisquam hic corporis deserunt!
                </p-->
              </div>
              <div class="btnVerMas">
                <!--button type="button" mdbBtn class="btnBanner" mdbWavesEffect>Ver más</button--> &nbsp;&nbsp;
              </div>
              <div class="banner-container">
                <img class="d-block w-100 banner-image" src="assets/image/banner/banner_1.png" 
                      alt="First slide">
              </div>
            </a>  
          </mdb-carousel-item>
          <mdb-carousel-item>
            <a class="w-100">
                <!--div class="divTexto"-->
                <div class="carrusel-position-text">  
                  <p class="tituloBanner">
                    
                  </p>
                  <!--p class="descripBanner">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti fugit ea eaque libero aut autem sed quisquam hic corporis deserunt!
                  </p-->
                </div>
                <div class="botones">
                  <div>
                    <!--button type="button" mdbBtn class="btnBanner" mdbWavesEffect>Ver más</button--> &nbsp;&nbsp;
                  </div>
              </div>
              <div class="banner-container">
                <img class="d-block w-100 banner-image" src="assets/image/banner/banner_2.png"
                     alt="Second slide">
              </div>              
            </a>
          </mdb-carousel-item>
          <mdb-carousel-item>
            <a class="w-100">
              <!--div class="divTexto"-->
              <div class="carrusel-position-text">
                <p class="tituloBanner">
                  
                </p>
                <!--p class="descripBanner">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti fugit ea eaque libero aut autem sed quisquam hic corporis deserunt!
                </p-->
              </div>
              <div class="botones">
                <div>
                  <!--button type="button" mdbBtn class="btnBanner" mdbWavesEffect>Ver más</button--> &nbsp;&nbsp;
                </div>
              </div>
              <div class="banner-container">
                <img class="d-block w-100 banner-image" src="assets/image/banner/banner_3.png"
                     alt="Third slide">
              </div>
            </a>
          </mdb-carousel-item>
        </mdb-carousel>
      </div>
    </div>
  </div>
</div>
<div class="movil">
  <div class="carruselContainerM">
    <div class="carruselCenterM">
      <div class="container-fluid" style="width:100%;padding: 0;">
        <mdb-carousel [animation]="'fade'" style="padding: 0;margin: 0;">
          <mdb-carousel-item>
            <a class="w-100">
              <!--div class="divTexto"-->
              <div class="carrusel-position-textm">
                <p class="tituloBannerM">
                  
                </p>
                <!--p class="descripBannerM">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti fugit ea eaque libero aut autem sed quisquam hic corporis deserunt!
                </p-->
              </div> 
              <div class="botonesM">
                <!--button type="button" mdbBtn class="btnBanner" mdbWavesEffect>Ver más</button--> &nbsp;&nbsp;
              </div>
              <div class="banner-containerM">
                <img class="d-block w-100 banner-image-m" src="assets/image/banner/banner_1.png" alt="First slide">
              </div>
            </a>  
          </mdb-carousel-item>
          <mdb-carousel-item>
            <a class="w-100">
                <div class="carrusel-position-textm">
                  <p class="tituloBannerM">
                    
                  </p>
                  <!--p class="descripBannerM">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti fugit ea eaque libero aut autem sed quisquam hic corporis deserunt!
                  </p-->
                </div>
                <div class="botonesM">
                  <div>
                    <!--button type="button" mdbBtn class="btnBanner" mdbWavesEffect>Ver más</button--> &nbsp;&nbsp;
                  </div>
              </div>
              <div class="banner-containerM">
                <img class="d-block w-100 banner-image-m" src="assets/image/banner/banner_2.png" alt="Second slide">
              </div>
            </a>
          </mdb-carousel-item>
          <mdb-carousel-item>
            <a class="w-100">
              <div class="carrusel-position-textm">
                <p class="tituloBannerM">
                  
                </p>
                <!--p class="descripBannerM">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti fugit ea eaque libero aut autem sed quisquam hic corporis deserunt!
                </p-->
              </div>
              <div class="botonesM">
                <div>
                  <!--button type="button" mdbBtn class="btnBanner" mdbWavesEffect>Ver más</button--> &nbsp;&nbsp;
                </div>
              </div>
              <div class="banner-containerM">
                <img class="d-block w-100 banner-image-m" src="assets/image/banner/banner_3.png" alt="Third slide">
              </div>
            </a>
          </mdb-carousel-item>
        </mdb-carousel>
      </div>
    </div>
  </div>      
</div>